import CustomLayout from "./wrapPageElement"
import "./src/global.scss"

export const wrapPageElement = CustomLayout